module.exports = __webpack_public_path__ + "static/highway-orange-66e8e51cc1e76a0f8805289851cae52f.png";